var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,26,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,26,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,26,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,26,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,42,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,42,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,42,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,42,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,42,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,42,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,58,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,58,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,58,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,58,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,58,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,74,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,74,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,74,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,74,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,90,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,90,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,90,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,90,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,90,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,106,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,106,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,106,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,106,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,106,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,106,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,106,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,122,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,122,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,122,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,122,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,122,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,122,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,122,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,138,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,138,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,138,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,154,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,154,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,154,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,154,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,154,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,154,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,154,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,154,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,154,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,154,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,154,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,154,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,154,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,154,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,170,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,170,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,170,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,170,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,170,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,170,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,170,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,170,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,170,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,170,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,170,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,170,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,170,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,170,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,186,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,186,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,186,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,186,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,186,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,186,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,186,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,186,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,186,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,186,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,186,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,186,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,186,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,186,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,186,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,186,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,186,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,186,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,186,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,186,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,186,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,186,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,202,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,202,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,202,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,202,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,202,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,202,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,202,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,202,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,202,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,202,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,202,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,218,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,218,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,218,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,218,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,218,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,218,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,218,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,218,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,218,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,218,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,218,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,218,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,218,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,218,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,218,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,218,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,234,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,234,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,234,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,234,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,234,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,234,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,234,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,234,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,234,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,234,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,234,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,234,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,234,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,234,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,234,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,250,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,250,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,250,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,250,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,250,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,250,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,250,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,250,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,250,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,250,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,250,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,250,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,250,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,250,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,250,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,250,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,250,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,250,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,266,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,266,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,266,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,266,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,266,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,266,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,266,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,266,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,282,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,282,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,282,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,282,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,282,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,282,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,282,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,282,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,282,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,282,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,282,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,282,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,298,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,298,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,298,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,298,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,298,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,298,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,298,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,298,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,298,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,298,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,298,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,298,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,298,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,314,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,314,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,314,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,314,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,314,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,314,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,314,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,314,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,314,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,314,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,314,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,330,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,330,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,330,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,330,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,330,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,330,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,330,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,330,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,330,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,330,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,330,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,330,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,330,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,330,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,330,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,346,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,346,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,346,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,346,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,346,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,346,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,346,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,346,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,346,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,346,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,346,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,346,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,346,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,346,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,346,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,346,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,346,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,346,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,346,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,346,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,346,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,362,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,362,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,362,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,362,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,362,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,362,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,362,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,362,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,362,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,362,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,362,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,378,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,378,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,378,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,378,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,378,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,378,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,378,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,378,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,378,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,378,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,378,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,394,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,394,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,394,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,394,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,394,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,394,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,394,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,394,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,394,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,410,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,410,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,410,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,410,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,410,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,410,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,410,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,410,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,410,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,410,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,410,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,410,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,410,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,426,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,426,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,426,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,426,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,426,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,426,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,426,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,426,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,442,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,442,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,442,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,442,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,442,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,442,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,442,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,442,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,458,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,458,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,458,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,458,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,458,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,458,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,458,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,458,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,458,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,458,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,474,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,474,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,474,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,474,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,474,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,474,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,474,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,474,458)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 18 18v 112h 112v -112zM 34 34h 80v 80h -80z",
    transform: "rotate(0,74,74)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 48,
    height: 48,
    transform: "rotate(0,74,74)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 370 18v 112h 112v -112zM 386 34h 80v 80h -80z",
    transform: "rotate(90,426,74)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 50,
    width: 48,
    height: 48,
    transform: "rotate(90,426,74)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 18 370v 112h 112v -112zM 34 386h 80v 80h -80z",
    transform: "rotate(-90,74,426)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 402,
    width: 48,
    height: 48,
    transform: "rotate(-90,74,426)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#18417E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    height: 112,
    width: 112,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#18417E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    height: 48,
    width: 48,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#18417E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 18,
    height: 112,
    width: 112,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#18417E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 50,
    height: 48,
    width: 48,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#18417E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 370,
    height: 112,
    width: 112,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#18417E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 402,
    height: 48,
    width: 48,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#18417E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.4eb8ffad14236c1d2b84ddef25c2e022.svg";
export { ForwardRef as ReactComponent };